import { render, staticRenderFns } from "./LogementStep.vue?vue&type=template&id=2788520d"
import script from "./LogementStep.vue?vue&type=script&lang=js"
export * from "./LogementStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports